import { site } from '../../../mocks/guaData';

const group1 = [
  { href: '#hot', label: '今日热榜' },
  { href: '#category', label: '热门栏目' },
  { href: '#moments', label: '名场面' },
  { href: '#feeds', label: '热闻速览' },
];

const group2 = [
  { href: '#faq', label: '常见问题' },
  { href: '#subscribe', label: '订阅速报' },
  { href: '#top', label: '回到顶部' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2" aria-label="反差吃瓜">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="whitespace-nowrap text-lg font-black tracking-wide text-foreground-950">
                反差<span className="text-primary-600">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {site.desc} 我们坚持事实核实、不站队不抢跑，把台前与幕后、人设与真实的反差名场面整理成一份份清晰的事件合集，帮你高效追瓜。
            </p>
            <div className="mt-5 flex gap-2">
              {['ri-weibo-line', 'ri-instagram-line', 'ri-youtube-line', 'ri-rss-line'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交关注入口"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-200 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-sm font-bold text-foreground-950">追瓜指南</h5>
            <ul className="mt-4 flex flex-col gap-2.5">
              {group1.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-sm font-bold text-foreground-950">关于我们</h5>
            <ul className="mt-4 flex flex-col gap-2.5">
              {group2.map((l) => (
                <li key={l.href + l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h5 className="text-sm font-bold text-foreground-950">反馈与投稿</h5>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果你看到反差名场面或想反馈内容，欢迎发邮件给我们：
            </p>
            <a
              href="mailto:fancha@chigua.example.com"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 ring-1 ring-background-200 transition hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              fancha@chigua.example.com
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 {site.name} · 反差吃瓜事件合集 · 本站内容仅供参考娱乐，涉及真实人物均已脱敏处理
          </p>
          <p className="flex items-center gap-1 text-xs text-foreground-500">
            吃瓜有度，理性追热点
            <i className="ri-heart-3-fill text-primary-500" aria-hidden="true"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}